import { render, staticRenderFns } from "./prePayFeeDetail.vue?vue&type=template&id=bf27b2b4&scoped=true"
import script from "./prePayFeeDetail.vue?vue&type=script&lang=js"
export * from "./prePayFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./prePayFeeDetail.vue?vue&type=style&index=0&id=bf27b2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf27b2b4",
  null
  
)

export default component.exports